import { Translation } from 'cng-common/features/translations/components/translation'
import { ModalDialog } from 'core-components/library/modalDialog'

import { TRANSLATION_KEYS } from '../../../translations'

import { RejectDialogContent, RejectDialogProps } from './components/rejectDialogContent'

import styles from './MDOffboardingRejectDialog.module.scss'

type Props = RejectDialogProps & { show: boolean }

export const MDOffboardingRejectDialog = ({
  show,
  onReject,
  onCancel,
  isPending,
  isError,
}: Props) => (
  <ModalDialog
    header={() => (
      <span className={styles.dialogTitle}>
        <Translation text={TRANSLATION_KEYS.rejectTitle} span />
      </span>
    )}
    size="sm"
    show={show}
    onClose={onCancel}
    closeOnOutsideClick={false}
    isContainerRestricted={false}
    content={RejectDialogContent}
    contentProps={{ onReject, onCancel, isPending, isError }}
  />
)
